// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"29":"fe62c4f7","441":"fe62c4f7"}[chunkId] + ".chunk.css";
};